import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const SeparatorLine = styled.hr`
  background-color: ${props => props.color};
  margin-top: ${props => props.marginTop};
  width: ${props => props.width};
  margin-bottom: 0;
`

export default function Separator(props) {
  const { marginTop, width, color } = props
  return <SeparatorLine marginTop={marginTop} width={width} color={color} />
}

Separator.propTypes = {
  marginTop: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
}

Separator.defaultProps = {
  marginTop: '2em',
  width: '100%',
  color: '#f7f8ff',
}
